import React from "react";
import DataSourceListWidget from "../../components/Widgets/DataSourceWidgets/DataSourceListWidget";

const SourcesArchivePage = () => {
  return <DataSourceListWidget archive={true} />;
};
export default SourcesArchivePage;
